import _ from 'lodash';
import React from 'react';
import { InvoiceStatusFilter } from '~/components';
import AccountingIntegrationFilter from '~/components/filters/AccountingIntegrationFilter';
import InvoiceSentFilter from '~/components/filters/InvoiceSentFilter';
import { useIntegrations } from '~/contexts/IntegrationsContext';
import ReportPeriodFilter from './ReportPeriodFilter';
import InvoiceItemFilter from './InvoiceItemFilter';

export default function InvoiceFiltersBar({ filters, onChange }) {
  const integrations = useIntegrations();
  return (
    <>
      {(filters.invoiceServicesThroughPeriod?.start || filters.invoiceServicesThroughPeriod?.end) && (
        <ReportPeriodFilter
          value={filters.invoiceServicesThroughPeriod}
          placeholder="Services Through Date Range"
          onChange={({ target: { value } }) => onChange({ invoiceServicesThroughPeriod: value })}
        />
      )}

      {!_.isEmpty(filters.invoiceStatuses) && (
        <InvoiceStatusFilter
          value={filters.invoiceStatuses}
          onChange={({ target: { value } }) => onChange({ invoiceStatuses: value })}
        />
      )}

      {!_.isEmpty(filters.invoiceSent) && (
        <InvoiceSentFilter
          value={filters.invoiceSent}
          onChange={({ target: { value } }) => onChange({ invoiceSent: value })}
        />
      )}

      {!_.isEmpty(filters.invoiceItems) && (
        <InvoiceItemFilter
          value={filters.invoiceItems}
          onChange={({ target: { value } }) => onChange({ invoiceItems: value })}
        />
      )}

      {integrations.accounting && !_.isEmpty(filters.invoiceAccountingIntegrations) && (
        <AccountingIntegrationFilter
          value={filters.invoiceAccountingIntegrations}
          onChange={({ target: { value } }) => onChange({ invoiceAccountingIntegrations: value })}
        />
      )}
    </>
  );
}
